export function getRate() {
    let vW = document.documentElement.clientWidth;//window.innerWidth; // 当前窗口的宽度
    let vH = document.documentElement.clientHeight;//window.innerHeight; // 当前窗口的高度
    const dHeight = 937;//1080
    let dueH = vW * dHeight / 1920;//937
    if (vH < dueH) { // 当前屏幕高度小于应有的屏幕高度，就需要根据当前屏幕高度重新计算屏幕宽度
       return vW = vH / dHeight
    }else{
        return document.documentElement.clientWidth / 1920;
    }
}